import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, FileText, Code } from 'lucide-react';
import { exportToCSV, exportToJSON } from '../../utils/adminUtils';

const ExportButton = ({ data, filename = 'export', label = 'Export' }) => {
    const [showMenu, setShowMenu] = useState(false);

    const handleExport = (format) => {
        if (format === 'csv') {
            exportToCSV(data, `${filename}.csv`);
        } else if (format === 'json') {
            exportToJSON(data, `${filename}.json`);
        }
        setShowMenu(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setShowMenu(!showMenu)}
                className="flex items-center gap-2 px-4 py-2 bg-black/40 hover:bg-black/60 border border-white/10 rounded-xl text-white transition-all"
                disabled={!data || data.length === 0}
            >
                <Download className="w-4 h-4" />
                <span className="text-sm font-medium">{label}</span>
            </button>

            <AnimatePresence>
                {showMenu && (
                    <>
                        <div
                            className="fixed inset-0 z-10"
                            onClick={() => setShowMenu(false)}
                        />
                        <motion.div
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            className="absolute right-0 mt-2 w-48 bg-[#1a1a1a] border border-white/10 rounded-xl shadow-xl overflow-hidden z-20"
                        >
                            <button
                                onClick={() => handleExport('csv')}
                                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-white/5 text-white transition-colors"
                            >
                                <FileText className="w-4 h-4 text-brand-teal" />
                                <span className="text-sm">Export as CSV</span>
                            </button>
                            <button
                                onClick={() => handleExport('json')}
                                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-white/5 text-white transition-colors border-t border-white/5"
                            >
                                <Code className="w-4 h-4 text-purple-400" />
                                <span className="text-sm">Export as JSON</span>
                            </button>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ExportButton;
